import React from 'react';
import { Box, Typography } from '@mui/material';
import Countdown from 'react-countdown';
import './OurStory.css';

const OurStory = () => {

  return (
    <Box className="video-container">
  <Typography variant="h5" className="watch-story-heading">
    Watch Our Story
  </Typography>
  <div className="responsive-iframe">
    <iframe
      src="https://www.youtube.com/embed/wGwBP3IhSNc"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</Box>
  );
};

export default OurStory;
